import { Component } from 'react';
import { assoc, isNil } from 'ramda';

import { MapNoteSheetEditable } from '../../components';
import s from './HostStyles.module.scss';

const initialState = {
    mapNote: {
        id: 0,
        subject: 'Playground Map Note',
        noteType: 'mapRequest',
        createdBy: { email: 'test@test.com' },
    },
    userEmail: 'test@test.com',
    updatedFields: {},
};

export default class MapNoteSheetEditableHost extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }

    onSubjectChange = text => {
        const { updatedFields } = this.state;
        this.setState({ updatedFields: assoc('subject', text, updatedFields) });
    };

    onTypeChange = newValue => {
        const { updatedFields } = this.state;
        this.setState({ updatedFields: assoc('noteType', newValue, updatedFields) });
    };

    render() {
        const hasNote = !isNil(this.state.mapNote);
        return (
            <div className={s.editor} style={{ padding: '100px' }}>
                {hasNote && (
                    <MapNoteSheetEditable
                        userEmail={this.state.userEmail}
                        mapNote={this.state.mapNote}
                        updatedFields={this.state.updatedFields}
                        onSubjectChange={this.onSubjectChange}
                        onTypeChange={this.onTypeChange}
                        onClose={() => this.setState({ mapNote: null })}
                        onTrash={() => this.setState({ mapNote: null })}
                        onSave={() => this.setState({ mapNote: null })}
                        onCancel={() => this.setState({ mapNote: null })}
                    />
                )}
                <button type="button" onClick={() => this.setState(initialState)} className={s.resetButton}>
                    Reset
                </button>
            </div>
        );
    }
}
